export default __webpack_public_path__ + "static/media/warning--traffic-signals--g4.9b34ae82.png";